import { Action } from '@ngrx/store';
import { CustomerPermissionsMW } from 'app/core/store/session/customer-permissions/customer-permissions.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';

export const CUSTOMER_PERMISSIONS_LOAD = 'authorization:CUSTOMER_PERMISSIONS_LOAD';
export const CUSTOMER_PERMISSIONS_LOAD_SUCCESS = 'authorization:CUSTOMER_PERMISSIONS_LOAD_SUCCESS';
export const CUSTOMER_PERMISSIONS_LOAD_FAIL = 'authorization:CUSTOMER_PERMISSIONS_LOAD_FAIL';

export class CustomerPermissionsLoadAction implements Action {
  readonly type = CUSTOMER_PERMISSIONS_LOAD;
  ui = {
    id: CUSTOMER_PERMISSIONS_LOAD,
    busy: true,
  };
}

export class CustomerPermissionsLoadSuccessAction implements Action {
  readonly type = CUSTOMER_PERMISSIONS_LOAD_SUCCESS;

  ui = {
    id: CUSTOMER_PERMISSIONS_LOAD,
    busy: false,
  };

  constructor(readonly payload: { customerPermissions: CustomerPermissionsMW; customers: Customer[] }) {}
}

export class CustomerPermissionsLoadFailAction implements Action {
  readonly type = CUSTOMER_PERMISSIONS_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: CUSTOMER_PERMISSIONS_LOAD,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export type Actions = CustomerPermissionsLoadAction | CustomerPermissionsLoadFailAction | CustomerPermissionsLoadSuccessAction;
